import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: 'app-history-import',
  templateUrl: './history-import.component.html'
})
export class HistoryImportComponent implements OnInit {
  public postId;
  public email: string;
  public numeroserial: string;
  public errorMessage;
  import: Import[];

  pageActual: number = 1;

  constructor(private http: HttpClient, private router: Router, private rutaActiva: ActivatedRoute, private cookies: CookieService) {
    var token = this.cookies.get("tokensessionTurista");
    if (token == "") {
      this.router.navigate(["/validate-email"]);
    }
  }

  ngOnInit() {
    let element: HTMLElement = document.getElementById('abrircargando') as HTMLElement;
    element.click();
    this.email = this.rutaActiva.snapshot.params.email
    this.numeroserial = this.rutaActiva.snapshot.params.numserial
    this.http.get<any>(`${environment.baseUrl}v1/import/1?email=` + this.email + "&numeroserial=" + this.numeroserial + "&status=&passportnumber=&importdate=&idimport=&approvednumber=&sectionaladdresin=")
      .subscribe({
        next: data => {
          this.import = data as Import[];
          let element: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
          element.click();
          //this.router.navigate(["/import-request/solicitud"]);
        },
        error: error => {
          this.errorMessage = error.message;
          let element: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
          element.click();
          //console.error('There was an error!', error);
        }
      })
  }

  onSearchClick(email, numberchasis,id) {
    this.router.navigate(["/import-request/" + "consulta" + "/" + email + "/" + numberchasis + "/" + id + "/history-import"]);
  }

  salir() {    
    //this.cookies.deleteAll(environment.raiz, environment.dominio)
    this.cookies.delete("tokensessionTurista", environment.raiz, environment.dominio)
    this.router.navigate(["/validate-email"]);
  }
}

class Import {
  id: string;
  sectionalAddressIn: string;
  sectionalAddressOut: string;
  touristName: string;
  touristCountry: string;
  passportNumber: string;
  nationality: string;
  dateOfArrival: string;
  touristCity: string;
  touristAddress: string;
  authorizedDuration: string;
  email: string;
  dateIn: string;
  dateOut: string;
  vehicleEntryForm: string;
  transportDocumentNumber: string;
  n1166DocumentNumber: string;
  ownershipDocumentNumber: string;
  registrationDate: string;
  typeClass: string;
  chassisNumber: string;
  licensePlate: string;
  make: string;
  model: string;
  engineNumber: string;
  countryOfRegistration: string;
  color: string;
  transportationName: string;
  nameFlag: string;
  entryPlace: string;
  registrationNumber: string;
  transportationChars: string;
  othersChars: string;
  idStatus: string;
  importDate: string;
  nombreContenedor: string;
}
